import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";

export const ConfirmModal = ({ open, setOpen, message }) => {
	// useEffect(() => {
	// 	let interval;
	// 	if (open) {
	// 		// setSeconds(3); // reset if reopened
	// 		// interval = setInterval(() => {
	// 		// 	setSeconds((prev) => {
	// 		// 		if (prev === 1) {
	// 		// 			clearInterval(interval);
	// 		// 			window.location.reload();
	// 		// 		}
	// 		// 		return prev - 1;
	// 		// 	});
	// 		// }, 1000);
	// 	}
	// 	return () => clearInterval(interval);
	// }, [open]);

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					variant="contained"
					onClick={() => setOpen(false)}
					autoFocus
				>
					Okay
				</Button>
			</DialogActions>
		</Dialog>
	);
};
